import Vue from 'vue'
import Vuex from 'vuex'

import { api } from '@/api'
import { validateCredentials } from '@/services/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    globalLoading: false,

    credentials: {
      numeroExame: '',
      cadMed: '',
      codConveniada: '',
      rotaUsername: '',
      password: ''
    },

    validCredentials: false

  },
  mutations: {

    startGlobalLoading (state) {
      state.globalLoading = true
    },
    stopGlobalLoading (state) {
      state.globalLoading = false
    },

    saveCredentials (state, payload) {
      for (const key in payload) {
        if (payload[key]) {
          state.credentials[key] = payload[key]
        }
      }
    },

    setCredentialsValid (state) {
      state.validCredentials = true
    },

    clearCredentials (state) {
      for (const key in state.credentials) {
        state.credentials[key] = ''
      }
      state.validCredentials = false
    }

  },
  actions: {

    async validateCredentials (context) {
      const result = await validateCredentials(context.state.credentials)

      if (!result?.success) {
        if (result?.message) {
          alert(result.message)
        } else {
          alert('Credenciais inválidas')
        }
        context.commit('clearCredentials')
      } else {
        context.commit('setCredentialsValid')
      }

      return result
    },

    async 'getExames-paciente' (context) {
      const response = await api.post('/exame/paciente', {
        protocolo: context.state.credentials.numeroExame,
        senha: context.state.credentials.password
      })

      console.log(response.data)

      context.commit('saveExames', response?.data || [])
    },

    async 'getExames-empresa' (context, months) {
      const response = await api.post('/exame/empresa', {
        username: context.state.credentials.codConveniada,
        password: context.state.credentials.password,
        months
      })

      console.log(response.data)

      context.commit('saveExames', response?.data || [])
    }
  },
  modules: {
  }
})
